(function(){
  var REPORT_PROXY_URL = 'https://cxnxfkaxlgisnxudpjgn.supabase.co/functions/v1/boulevard-booking-proxy';
  var BOULEVARD_TOKENIZE_URL = 'https://pci.boulevard.app/cards/tokenize';
  var app = document.getElementById('clientCardOnFileApp');
  if (!app) return;

  function normalizedConfigValue(value){
    var text = String(value || '').trim();
    if (!text) return '';
    if (text === 'USE_PROXY_DEFAULT_LOCATION' || text === 'REPLACE_WITH_WAITLIST_SERVICE_ID') return '';
    return text;
  }

  var configuredLocationId = normalizedConfigValue(app.getAttribute('data-location-id'));
  var phoneInput = document.getElementById('clientCardPhone');
  var codeInput = document.getElementById('clientCardCode');
  var sendCodeBtn = document.getElementById('clientCardSendCodeBtn');
  var verifyBtn = document.getElementById('clientCardVerifyBtn');
  var submitBtn = document.getElementById('clientCardSubmitBtn');
  var statusNode = document.getElementById('clientCardStatus');
  var codeWrap = document.getElementById('clientCardCodeWrap');
  var verifiedClientCard = document.getElementById('clientCardVerifiedClient');
  var clientNameNode = document.getElementById('clientCardName');
  var clientMetaNode = document.getElementById('clientCardMeta');
  var walletSummary = document.getElementById('clientCardWalletSummary');
  var walletTitleNode = document.getElementById('clientCardWalletTitle');
  var walletMetaNode = document.getElementById('clientCardWalletMeta');
  var walletListNode = document.getElementById('clientCardWalletList');
  var addAnotherBtn = document.getElementById('clientCardAddAnotherBtn');
  var formStep = document.getElementById('clientCardFormStep');
  var cardNameInput = document.getElementById('clientCardNameOnCard');
  var cardNumberInput = document.getElementById('clientCardNumber');
  var cardExpMonthInput = document.getElementById('clientCardExpMonth');
  var cardExpYearInput = document.getElementById('clientCardExpYear');
  var cardCvvInput = document.getElementById('clientCardCvv');
  var cardPostalInput = document.getElementById('clientCardPostal');
  var state = {
    sending: false,
    verifying: false,
    loadingWallet: false,
    submitting: false,
    requestId: '',
    clientToken: '',
    client: null,
    cards: [],
    formExpanded: true,
    saveSucceeded: false
  };

  function normalizeString(value){
    return String(value == null ? '' : value).trim();
  }

  function digitsOnly(value){
    return normalizeString(value).replace(/\D+/g, '');
  }

  function formatPhone(value){
    var digits = digitsOnly(value);
    if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return '(' + digits.slice(0, 3) + ') ' + digits.slice(3);
    return '(' + digits.slice(0, 3) + ') ' + digits.slice(3, 6) + '-' + digits.slice(6, 10);
  }

  function formatCardNumber(value){
    var digits = digitsOnly(value).slice(0, 19);
    return digits.replace(/(.{4})/g, '$1 ').trim();
  }

  function setStatus(message, tone){
    if (!statusNode) return;
    var text = normalizeString(message);
    if (!text) {
      statusNode.hidden = true;
      statusNode.textContent = '';
      statusNode.removeAttribute('data-tone');
      return;
    }
    statusNode.hidden = false;
    statusNode.textContent = text;
    if (tone) statusNode.setAttribute('data-tone', tone);
    else statusNode.removeAttribute('data-tone');
  }

  async function proxyRequest(payload){
    var response = await fetch(REPORT_PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload || {})
    });
    var rawText = await response.text();
    var data = null;
    try {
      data = rawText ? JSON.parse(rawText) : null;
    } catch (_error) {
      data = null;
    }
    if (!response.ok || !data || data.ok !== true) {
      throw new Error((data && (data.error || data.message)) || rawText || 'Request failed.');
    }
    return data;
  }

  async function tokenizeCard(card){
    var response = await fetch(BOULEVARD_TOKENIZE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        card: {
          name: card.name,
          number: card.number,
          cvv: card.cvv,
          exp_month: Number(card.exp_month),
          exp_year: Number(card.exp_year),
          address_postal_code: card.address_postal_code
        }
      })
    });

    var data = await response.json().catch(function(){ return null; });
    if (!response.ok || !data) throw new Error('Could not tokenize card.');
    var token = data.id || data.token || data.card_token || (data.data && (data.data.id || data.data.token)) || '';
    if (!token) throw new Error('Could not tokenize card.');
    return token;
  }

  function validCards(){
    return (Array.isArray(state.cards) ? state.cards : []).filter(function(card){
      return card && card.is_expired !== true;
    });
  }

  function dedupeCards(cards){
    var seen = {};
    return (Array.isArray(cards) ? cards : []).filter(function(card){
      if (!card) return false;
      var brand = normalizeString(card.brand).toLowerCase();
      var last4 = normalizeString(card.last4);
      var expMonth = String(card.exp_month == null ? '' : card.exp_month);
      var expYear = String(card.exp_year == null ? '' : card.exp_year);
      var id = normalizeString(card.id);
      var key = [brand, last4, expMonth, expYear].join('::');
      if (key === ':::') key = id;
      if (!key || seen[key]) return false;
      seen[key] = true;
      return true;
    });
  }

  function clearCardFields(){
    if (cardNameInput) cardNameInput.value = normalizeString(state.client && state.client.name);
    if (cardNumberInput) cardNumberInput.value = '';
    if (cardExpMonthInput) cardExpMonthInput.value = '';
    if (cardExpYearInput) cardExpYearInput.value = '';
    if (cardCvvInput) cardCvvInput.value = '';
    if (cardPostalInput) cardPostalInput.value = '';
  }

  function renderWallet(){
    if (!walletSummary) return;
    var cards = dedupeCards(state.cards);
    var currentValidCards = validCards();
    walletSummary.hidden = !state.clientToken;
    if (!state.clientToken) return;
    if (walletTitleNode) {
      walletTitleNode.textContent = currentValidCards.length
        ? 'A valid card is already on file.'
        : 'No valid card is on file yet.';
    }
    if (walletMetaNode) {
      walletMetaNode.textContent = currentValidCards.length
        ? 'A valid card is already saved for phone booking.'
        : 'No valid card is currently saved for phone booking.';
    }
    if (walletListNode) {
      walletListNode.innerHTML = cards.length
        ? cards.map(function(card){
            var title = normalizeString(card.name) || [normalizeString(card.brand), normalizeString(card.last4) ? '•••• ' + normalizeString(card.last4) : ''].filter(Boolean).join(' ');
            var meta = [
              card.exp_month && card.exp_year ? 'Expires ' + String(card.exp_month).padStart(2, '0') + '/' + String(card.exp_year) : '',
              card.is_expired === true ? 'Expired' : 'Valid'
            ].filter(Boolean).join(' • ');
            return '<div class="client-card-walletItem"><strong>' + title + '</strong><span class="client-card-walletItemMeta">' + meta + '</span></div>';
          }).join('')
        : '<div class="client-card-walletItem"><strong>No saved cards</strong><span class="client-card-walletItemMeta">Card required to complete phone booking</span></div>';
    }
    if (addAnotherBtn) {
      addAnotherBtn.hidden = !state.clientToken || !currentValidCards.length || state.formExpanded;
    }
    if (formStep) {
      formStep.hidden = !state.clientToken || !state.formExpanded;
    }
  }

  function readCardFields(){
    return {
      name: normalizeString(cardNameInput && cardNameInput.value),
      number: digitsOnly(cardNumberInput && cardNumberInput.value),
      expMonth: digitsOnly(cardExpMonthInput && cardExpMonthInput.value).slice(0, 2),
      expYear: digitsOnly(cardExpYearInput && cardExpYearInput.value).slice(0, 4),
      cvv: digitsOnly(cardCvvInput && cardCvvInput.value).slice(0, 4),
      postal: normalizeString(cardPostalInput && cardPostalInput.value)
    };
  }

  function validateCardFields(card){
    if (!card.name) throw new Error('Enter the name on the card.');
    if (card.number.length < 13) throw new Error('Enter a valid card number.');
    if (card.expMonth.length < 1) throw new Error('Enter the expiration month.');
    var month = Number(card.expMonth);
    if (!Number.isFinite(month) || month < 1 || month > 12) throw new Error('Enter a valid expiration month.');
    if (card.expYear.length !== 4) throw new Error('Enter the 4-digit expiration year.');
    if (card.cvv.length < 3) throw new Error('Enter a valid CVV.');
    if (!card.postal) throw new Error('Enter the billing ZIP code.');
  }

  function updateUI(){
    var busy = state.sending || state.verifying || state.loadingWallet || state.submitting;
    if (sendCodeBtn) sendCodeBtn.disabled = busy;
    if (verifyBtn) verifyBtn.disabled = busy;
    if (submitBtn) submitBtn.disabled = busy || !state.clientToken;
    if (codeWrap) codeWrap.hidden = !state.requestId;
    if (verifiedClientCard) verifiedClientCard.hidden = !state.client || state.saveSucceeded;

    if (state.client) {
      var name = normalizeString(state.client.name) || 'Verified client';
      var phone = normalizeString(state.client.mobilePhone);
      var email = normalizeString(state.client.email);
      if (clientNameNode) clientNameNode.textContent = name;
      if (clientMetaNode) clientMetaNode.textContent = [formatPhone(phone), email].filter(Boolean).join(' • ');
      if (cardNameInput && !normalizeString(cardNameInput.value)) {
        cardNameInput.value = name;
      }
    }

    renderWallet();
  }

  async function loadWallet(){
    if (!state.clientToken) throw new Error('Verify your phone first.');
    state.loadingWallet = true;
    updateUI();
    try {
      var data = await proxyRequest({
        action: 'client-dashboard-data',
        client_token: state.clientToken
      });
      state.client = data.profile || state.client;
      state.cards = Array.isArray(data.cards) ? data.cards : [];
      updateUI();
    } finally {
      state.loadingWallet = false;
      updateUI();
    }
  }

  async function sendCode(){
    var phone = normalizeString(phoneInput && phoneInput.value);
    if (!phone) throw new Error('Enter your phone number first.');
    state.sending = true;
    updateUI();
    try {
      var data = await proxyRequest({
        action: 'client-auth-start',
        method: 'phone',
        identifier: phone
      });
      state.requestId = normalizeString(data.request_id);
      setStatus(data.note || 'Verification code sent.', 'success');
      updateUI();
      if (codeInput) codeInput.focus();
    } finally {
      state.sending = false;
      updateUI();
    }
  }

  async function verifyCode(){
    var phone = normalizeString(phoneInput && phoneInput.value);
    var code = normalizeString(codeInput && codeInput.value);
    if (!phone) throw new Error('Enter your phone number first.');
    if (!state.requestId) throw new Error('Send a code first.');
    if (!code) throw new Error('Enter the code we texted you.');

    state.verifying = true;
    updateUI();
    try {
      var data = await proxyRequest({
        action: 'client-auth-verify',
        method: 'phone',
        identifier: phone,
        request_id: state.requestId,
        code: code
      });
      state.clientToken = normalizeString(data.client_token);
      state.client = data.client || null;
      state.saveSucceeded = false;
      if (!state.clientToken || !state.client || !normalizeString(state.client.id)) {
        throw new Error('We could not confirm your Boulevard client account.');
      }
      setStatus('Phone verified. Checking your saved card status now.', 'success');
      await loadWallet();
      if (validCards().length) {
        state.formExpanded = false;
        setStatus('You already have a valid card on file for booking. Use the form below only if you want to replace it.', 'success');
      } else {
        state.formExpanded = true;
        setStatus('No valid card is currently saved on file. Add one below so we can securely hold your phone booking.', 'error');
      }
      updateUI();
    } finally {
      state.verifying = false;
      updateUI();
    }
  }

  async function saveCard(){
    if (!state.clientToken) throw new Error('Verify your phone first.');
    var card = readCardFields();
    validateCardFields(card);

    state.submitting = true;
    updateUI();
    try {
      var cardToken = await tokenizeCard({
        name: card.name,
        number: card.number,
        cvv: card.cvv,
        exp_month: card.expMonth,
        exp_year: card.expYear,
        address_postal_code: card.postal
      });
      var data = await proxyRequest({
        action: 'client-wallet-add-card',
        client_token: state.clientToken,
        card_token: cardToken,
        location_id: configuredLocationId,
        nickname: card.name,
        card_last4: card.number.slice(-4),
        card_exp_month: Number(card.expMonth),
        card_exp_year: Number(card.expYear)
      });
      state.cards = Array.isArray(data.cards) ? data.cards : [];
      updateUI();
      if (data.saved_card_added) {
        state.saveSucceeded = true;
        state.formExpanded = false;
        clearCardFields();
        setStatus(data.message || 'Card saved. Your Boulevard account now has a valid card on file for booking.', 'success');
      } else {
        setStatus(data.message || 'We could not confirm that the new card was saved to the Boulevard wallet.', 'error');
      }
      updateUI();
    } finally {
      state.submitting = false;
      updateUI();
    }
  }

  if (phoneInput) {
    phoneInput.addEventListener('input', function(){
      phoneInput.value = formatPhone(phoneInput.value);
    });
  }
  if (cardNumberInput) {
    cardNumberInput.addEventListener('input', function(){
      cardNumberInput.value = formatCardNumber(cardNumberInput.value);
    });
  }
  if (cardExpMonthInput) {
    cardExpMonthInput.addEventListener('input', function(){
      cardExpMonthInput.value = digitsOnly(cardExpMonthInput.value).slice(0, 2);
    });
  }
  if (cardExpYearInput) {
    cardExpYearInput.addEventListener('input', function(){
      cardExpYearInput.value = digitsOnly(cardExpYearInput.value).slice(0, 4);
    });
  }
  if (cardCvvInput) {
    cardCvvInput.addEventListener('input', function(){
      cardCvvInput.value = digitsOnly(cardCvvInput.value).slice(0, 4);
    });
  }
  if (sendCodeBtn) {
    sendCodeBtn.addEventListener('click', async function(){
      try {
        await sendCode();
      } catch (error) {
        setStatus(error instanceof Error ? error.message : String(error), 'error');
      }
    });
  }
  if (verifyBtn) {
    verifyBtn.addEventListener('click', async function(){
      try {
        await verifyCode();
      } catch (error) {
        setStatus(error instanceof Error ? error.message : String(error), 'error');
      }
    });
  }
  if (submitBtn) {
    submitBtn.addEventListener('click', async function(){
      try {
        await saveCard();
      } catch (error) {
        setStatus(error instanceof Error ? error.message : String(error), 'error');
      }
    });
  }
  if (addAnotherBtn) {
    addAnotherBtn.addEventListener('click', function(){
      state.saveSucceeded = false;
      state.formExpanded = true;
      clearCardFields();
      setStatus('', '');
      updateUI();
      if (cardNumberInput) cardNumberInput.focus();
    });
  }
  updateUI();
})();
